import React from "react";
import { Facebook, Twitter, MessageCircle, Send, Globe } from "lucide-react";

export function Footer() {
    return (
        <footer className="w-full border-t border-zinc-800 py-6 bg-gray-100 dark:bg-zinc-900">
            <div className="container flex flex-col items-center justify-center gap-4 md:h-auto">
                <div className="flex gap-4 mt-2">
                    <a href="https://www.facebook.com/MandaloAsiNoma" target="_blank" rel="noopener noreferrer"
                       aria-label="Facebook">
                        <img src="/facebook-logo.svg" alt="FACEBOOK" className="w-8 h-8 hover:scale-125 transition-transform"/>
                    </a>
                    <a href="https://e-hentai.org/uploader/joyel124" target="_blank" rel="noopener noreferrer" aria-label="EH">
                        <img src="/e-hentai-logo.svg" alt="EH" className="w-8 h-8 hover:scale-125 transition-transform"/>
                    </a>
                    <a href="https://tmohentai.com/groups/3238" target="_blank" rel="noopener noreferrer" aria-label="TMOHENTAI">
                        <img src="/tmo-logo.png" alt="TMOHENTAI" className="w-8 h-8 hover:scale-125 transition-transform"/>
                    </a>
                    <a href="https://discord.gg/vzrNdabYYz" target="_blank" rel="noopener noreferrer" aria-label="Discord">
                        <img src="/discord-logo.svg" alt="DISCORD" className="w-8 h-8 bg hover:scale-125 transition-transform"/>
                    </a>
                    <a href="https://t.me/mandaloasinoma" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
                        <img src="/telegram-logo.svg" alt="TELEGRAM" className="w-8 h-8 hover:scale-125 transition-transform"/>
                    </a>
                </div>
                <p className="text-center text-sm leading-loose dark:text-zinc-400 text-zinc-900 md:text-left">
                    © 2024 MandaloAsiNoma.
                </p>
            </div>
        </footer>
    );
}
